import { render, staticRenderFns } from "./subAccount.vue?vue&type=template&id=4e42b12c&scoped=true&"
import script from "./subAccount.vue?vue&type=script&lang=js&"
export * from "./subAccount.vue?vue&type=script&lang=js&"
import style0 from "./subAccount.vue?vue&type=style&index=0&id=4e42b12c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e42b12c",
  null
  
)

export default component.exports